import React, { useContext } from 'react'

import { string, object, bool } from 'prop-types'

import { ModalContext } from '../../hooks'
import Button from '../Button'
import Text from '../Text'
import Title from '../Title'
import * as S from './styled'

const CardModule = ({
  label,
  title,
  body,
  totalPrice,
  price,
  action,
  showPrice,
  ...rest
}) => {
  const { setModalState, setCourse } = useContext(ModalContext)

  const actionParams = {
    title: action.label,
    ...action,
  }

  if (!action.href) {
    actionParams.onClick = () => {
      setModalState(true)
      setCourse(`${label} - ${title}`)
    }
  }

  return (
    <S.CardModuleWrapper {...rest}>
      <S.CardModuleHeading>
        <Title appearance="card-module" color="primary" afterTitle={title}>
          {label}
        </Title>
      </S.CardModuleHeading>

      {body && (
        <S.CardModuleBody>
          <Text size={18} marginBottom={16}>
            {body}
          </Text>
        </S.CardModuleBody>
      )}

      <S.CardModuleFooting>
        {showPrice && (
          <S.CardModulePrice>
            <S.CardModuleOldAmount>{totalPrice}</S.CardModuleOldAmount>
            <S.CardModuleAmount>EM ATÉ 10x</S.CardModuleAmount>
          </S.CardModulePrice>
        )}

        {action && (
          <Button fluid {...actionParams}>
            {action.label}
          </Button>
        )}
      </S.CardModuleFooting>
    </S.CardModuleWrapper>
  )
}

CardModule.propTypes = {
  showPrice: false,
}

CardModule.propTypes = {
  label: string,
  title: string,
  body: string,
  totalPrice: string,
  price: string,
  showPrice: bool,
  action: object,
}

export default CardModule
